import { CustomBoxV2 } from "components";
import { InactiveUserIcon } from "pages/internal-dashboard/icons";
import React from "react";

export function InActiveUser({ data, loading }: any) {
  return (
    <CustomBoxV2
      color="#F3B924"
      title="Inactive Users"
      userCount={data?.total?.count || 0}
      boxData={{
        label: "Inactive Users",

        todayCount: data?.today?.count || 0,
        weekCount: data?.thisWeek?.count || 0,
        monthCount: data?.thisMonth?.count || 0,
        yearCount: data?.thisYear?.count || 0,
        icon: InactiveUserIcon,
      }}
      percentages={{
        day: data?.today?.growth || 0,
        month: data?.month?.growth || 0,
        week: data?.week?.growth || 0,
        year: data?.year?.growth || 0,
      }}
      loading={loading}
    />
  );
}
